export const getReviewSummaryDialogueText = noOfDialoguesVoted => {
  if (noOfDialoguesVoted === 1) {
    return "You've endorsed {0} dialogue";
  } else {
    return "You've endorsed {0} dialogues";
  }
};